import { render, staticRenderFns } from "./AppVersionPopup.vue?vue&type=template&id=211fd5e8"
import script from "./AppVersionPopup.vue?vue&type=script&lang=js"
export * from "./AppVersionPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports